var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.emptyStr))])])}
var staticRenderFns = []

export { render, staticRenderFns }